module.exports = __webpack_public_path__ + "img/soft-grove-dining-1.5b14793e.jpeg";